import { useState } from 'react';
import { useToast } from './_barrel.js';


        // The "shown once" block after a tracker is created: the phone link,
        // the view-only map link and the background-app address — each with a
        // ready-to-send plain-text message (instructions included) so the
        // analyst never has to explain the setup by hand. Messages come from
        // the backend (share_message / view_message / app_message) so both the
        // Tracking tab and the subject panel say exactly the same thing.
        function IssuedLinks({ issued }) {
            const toast = useToast();
            const [copied, setCopied] = useState('');
            const [tab, setTab] = useState('page');   // 'page' | 'app' | 'view'
            if (!issued) return null;

            const copy = (text, which) => {
                if (!text) return;
                (navigator.clipboard ? navigator.clipboard.writeText(text) : Promise.reject())
                    .then(() => { setCopied(which); toast('Copied'); setTimeout(() => setCopied(''), 1500); })
                    .catch(() => toast('Copy failed — select the text and copy it manually'));
            };
            const send = (text) => {
                if (navigator.share) navigator.share({ text }).catch(() => { /* user cancelled */ });
                else copy(text, 'send');
            };

            const tabs = [
                ['page', 'Phone link + instructions'],
                ['app', 'Screen-off tracking (OwnTracks)'],
                ['view', 'Team map link'],
            ];
            const current = tab === 'page'
                ? { url: issued.share_url, message: issued.share_message,
                    note: 'Paste this into WhatsApp, a text or an email. It has the link and the steps: tap Share, allow location, add to Home Screen, keep the page open. Works without signal (fixes are saved and sent later), but only while the page is open on screen.' }
                : tab === 'app'
                ? { url: issued.app_url, message: issued.app_message,
                    note: 'For tracking that keeps going with the screen off or the phone in a pocket. The person installs the free OwnTracks app and pastes this address into it (HTTP mode). Same consent, same revoke, same map — the app just posts in the background, which no web page can do.' }
                : { url: issued.view_share_url, message: issued.view_message,
                    note: 'Read-only live map for the ops team — opens on any phone, no Veil login, cannot post location. Stops the moment you revoke.' };
            const btn = { padding: '6px 12px', fontSize: 13 };
            const ghost = { ...btn, border: '1px solid var(--line)', borderRadius: 6, background: 'transparent', color: 'var(--text)', cursor: 'pointer' };

            return (
                <div className="mt-3 p-3" style={{ border: '1px solid var(--gold)', borderRadius: 6 }}>
                    <div className="text-xs uppercase tracking-widest text-muted mb-2">Send to the phone — shown once, copy it now</div>
                    <div className="flex gap-2 mb-2" style={{ flexWrap: 'wrap' }}>
                        {tabs.map(([k, t]) => (
                            <button key={k} onClick={() => setTab(k)}
                                    style={{ ...ghost, borderColor: tab === k ? 'var(--gold)' : 'var(--line)', color: tab === k ? 'var(--gold)' : 'var(--text-dim)' }}>
                                {t}
                            </button>
                        ))}
                    </div>
                    <div className="text-xs text-muted mb-2">{current.note}</div>
                    <textarea readOnly value={current.message || current.url || ''} rows={9}
                              onFocus={e => e.target.select()}
                              style={{ width: '100%', background: 'var(--zone-2)', color: 'var(--text)', border: '1px solid var(--veil)',
                                       padding: '8px 10px', fontSize: 12, fontFamily: 'inherit', lineHeight: 1.45, resize: 'vertical' }} />
                    <div className="flex items-center gap-2 mt-2" style={{ flexWrap: 'wrap' }}>
                        <button className="btn-gold" style={btn} onClick={() => copy(current.message || current.url, 'msg')}>
                            {copied === 'msg' ? 'Copied ✓' : 'Copy message'}
                        </button>
                        <button style={ghost} onClick={() => copy(current.url, 'url')}>
                            {copied === 'url' ? 'Copied ✓' : 'Copy link only'}
                        </button>
                        {typeof navigator !== 'undefined' && navigator.share && (
                            <button style={ghost} onClick={() => send(current.message || current.url)}>Send…</button>
                        )}
                    </div>
                    <div className="text-xs text-muted mt-2">
                        The link is the credential — it is shown once and not stored. Revoke at any time to stop tracking and erase the trail.
                    </div>
                </div>
            );
        }

export { IssuedLinks };
